import { Directive, HostListener } from '@angular/core';

import { UXActionType } from '../../models';

import { AnalyticsActionBaseDirective } from './analytics-action.base.directive';

@Directive({
    selector: '[analyticsHover]',
})
export class AnalyticsHoverDirective extends AnalyticsActionBaseDirective {
    @HostListener('mouseenter')
    protected handleEvent() {
        super.track(UXActionType.Hover);
    }
}
